import type { GridColDef } from "@mui/x-data-grid-premium";
import { getGridDateOperators } from "@mui/x-data-grid-premium";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { requiredColDef } from "./misc";
import { useFormattedDateTime } from "./useFormattedDateTime";
import { Cell } from "./columnDefinitions";
import { getDateSortComparator } from "./dateSortComparator";
import { getDateQuickFilter } from "./dateQuickFilter";
import type { FormatDateOptions } from "../shared/formatDate";

export const dateTimeColumn = ({
  headerName,
  field,
  formatDate,
}: {
  headerName: string;
  field: string;
  formatDate: (date: string, options?: FormatDateOptions) => string;
}): GridColDef => {
  return {
    ...requiredColDef({ headerName, field }),
    filterOperators: [...getGridDateOperators()],
    width: 220,
    getSortComparator: getDateSortComparator,
    getApplyQuickFilterFn: getDateQuickFilter(date => formatDate(date, { showTime: true })),
    valueGetter: (_, row) => (row[field] ? new Date(row[field]) : null),
    renderCell: ({ row }) => (
      <Cell>
        <DateTimeCell value={row[field]} />
      </Cell>
    ),
  };
};

const DateTimeCell = ({ value }: { value: string }) => {
  const { formattedDate, formattedTimeElapsed } = useFormattedDateTime(value);

  return (
    <Stack sx={{ transform: "translateY(-3px)" }}>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14) }}>{formattedDate}</Typography>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(12), color: theme => theme.palette.text.tertiary }}>
        {formattedTimeElapsed}
      </Typography>
    </Stack>
  );
};
